module.exports = __webpack_public_path__ + "static/media/23.576df612.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shoes/23.png
// module id = 1064
// module chunks = 0